import { blobBytes } from '../mimo/storage';

/** Read real media metadata; never estimate duration from the reply text. */
export async function audioDuration(blob: Blob): Promise<number | null> {
  const bytes = await blobBytes(blob);
  const view = new DataView(bytes);
  const tag = (offset: number) => String.fromCharCode(...new Uint8Array(bytes, offset, 4));
  if (bytes.byteLength >= 44 && tag(0) === 'RIFF' && tag(8) === 'WAVE') {
    let rate = 0;
    let size = 0;
    for (let offset = 12; offset + 8 <= bytes.byteLength;) {
      const length = view.getUint32(offset + 4, true);
      if (tag(offset) === 'fmt ' && length >= 16 && offset + 24 <= bytes.byteLength) rate = view.getUint32(offset + 16, true);
      if (tag(offset) === 'data') size = Math.min(length, bytes.byteLength - offset - 8);
      offset += 8 + length + (length % 2);
    }
    if (rate > 0 && size > 0) return size / rate;
  }
  if (typeof URL.createObjectURL !== 'function') return null;
  return new Promise(resolve => {
    const media = new Audio();
    const url = URL.createObjectURL(blob);
    const done = () => {
      clearTimeout(timer);
      media.removeEventListener('loadedmetadata', done);
      media.removeEventListener('error', done);
      const duration = Number.isFinite(media.duration) && media.duration > 0 ? media.duration : null;
      media.removeAttribute('src');
      URL.revokeObjectURL(url);
      resolve(duration);
    };
    const timer = setTimeout(done, 5000);
    media.addEventListener('loadedmetadata', done);
    media.addEventListener('error', done);
    media.preload = 'metadata';
    media.src = url;
  });
}
